import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import DynamicTypography from '@/components/DynamicTypography'
import useOnboardingContext from '@/hooks/useOnboardingContext'
import capitalize from 'lodash/capitalize'
import useIsMobile from '../../../../hooks/useIsMobile'

const FormContainer = ({
  title,
  subtitle,
  center,
  children,
  contentWrapperClassName,
  /**
   * When set (e.g. gap-[20px]), title + subtitle are grouped and spaced from step body with flex gap.
   * Subtitle bottom margin is cleared so spacing is controlled only by this gap.
   */
  headerContentGapClassName,
  subtitleSx,
}) => {
  const { templateStyle } = useOnboardingContext()
  const { isMobile } = useIsMobile()
  const textAlign = center ? 'center' : 'inherit'

  const resolvedContentClassName =
    contentWrapperClassName ??
    (headerContentGapClassName
      ? 'flex flex-col gap-[16px]'
      : 'mt-5 flex flex-col gap-[16px]')

  const titleEl = (
    <Typography
      variant='h3'
      textAlign={textAlign}
      sx={{
        fontFamily: '"RB Galano Neue", Arial, sans-serif',
        fontWeight: 700,
        fontSize: '30px',
        color: '#1A1A1A',
        letterSpacing: '-2%',
        marginBottom: '16px',
      }}
    >
      {isMobile ? title.mobile : title.desktop}
    </Typography>
  )

  const subtitleEl = (
    <DynamicTypography
      variant='body2'
      text={isMobile ? subtitle.mobile : subtitle.desktop}
      textAlign={textAlign}
      themeType={capitalize(templateStyle)}
      sx={{
        fontSize: '14px',
        color: '#1A1A1A',
        ...(headerContentGapClassName ? { mb: 0 } : {}),
        ...subtitleSx,
      }}
    />
  )

  const contentEl = (
    <Box className={resolvedContentClassName}>
      {children}
    </Box>
  )

  if (headerContentGapClassName) {
    return (
      <Box className={`flex flex-col ${headerContentGapClassName}`}>
        <Box className='flex flex-col'>
          {titleEl}
          {subtitleEl}
        </Box>
        {contentEl}
      </Box>
    )
  }

  return (
    <Box className='flex flex-col'>
      {titleEl}
      {subtitleEl}
      {contentEl}
    </Box>
  )
}

FormContainer.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    center: PropTypes.bool,
    children: PropTypes.node,
    contentWrapperClassName: PropTypes.string,
    headerContentGapClassName: PropTypes.string,
    subtitleSx: PropTypes.object,
}


export default FormContainer
